import React from 'react';
import { Stack, Text, Checkbox } from '@fluentui/react';
import { ChecklistData } from '../types';
import IvicosStrings from 'kits/language/stringKit';

interface Props {
    checklistData: ChecklistData;
    setChecklistData: React.Dispatch<React.SetStateAction<ChecklistData>>;
}

const FirewallSettings: React.FC<Props> = ({ checklistData, setChecklistData }) => {
    const toggle = (key: keyof ChecklistData['firewallConfig'], checked: boolean) => {
        setChecklistData((prev) => ({
            ...prev,
            firewallConfig: {
                ...prev.firewallConfig,
                [key]: checked
            }
        }));
    };

    return (
        <Stack tokens={{ childrenGap: 10 }}>
            <Text variant="large">{IvicosStrings.webRTCDiagnosticsFirewallTitle}</Text>
            <Text>{IvicosStrings.webRTCDiagnosticsFirewallDescription}</Text>

            <Checkbox
                label={IvicosStrings.webRTCDiagnosticsFirewallTURNServer}
                checked={checklistData.firewallConfig.turnServer}
                onChange={(_, checked) => toggle('turnServer', checked || false)}
            />
            <Checkbox
                label={IvicosStrings.webRTCDiagnosticsFirewallJVBServer}
                checked={checklistData.firewallConfig.jvbServer}
                onChange={(_, checked) => toggle('jvbServer', checked || false)}
            />
            <Checkbox
                label={IvicosStrings.webRTCDiagnosticsFirewallJitsiServer}
                checked={checklistData.firewallConfig.jitsiServer}
                onChange={(_, checked) => toggle('jitsiServer', checked || false)}
            />
            <Checkbox
                label={IvicosStrings.webRTCDiagnosticsFirewallPort80}
                checked={checklistData.firewallConfig.port80}
                onChange={(_, checked) => toggle('port80', checked || false)}
            />
            <Checkbox
                label={IvicosStrings.webRTCDiagnosticsFirewallPort443}
                checked={checklistData.firewallConfig.port443}
                onChange={(_, checked) => toggle('port443', checked || false)}
            />
            <Checkbox
                label={IvicosStrings.webRTCDiagnosticsFirewallPort4443}
                checked={checklistData.firewallConfig.port4443}
                onChange={(_, checked) => toggle('port4443', checked || false)}
            />
            <Checkbox
                label={IvicosStrings.webRTCDiagnosticsFirewallPort10000}
                checked={checklistData.firewallConfig.port10000}
                onChange={(_, checked) => toggle('port10000', checked || false)}
            />
        </Stack>
    );
};

export default FirewallSettings;
